/* eslint-disable @typescript-eslint/no-explicit-any */
interface EventCallback<T = any> {
  (data: T): void;
}

interface EventBus {
  on<T = any>(event: string, callback: EventCallback<T>): void;
  dispatch<T = any>(event: string, data: T): void;
  remove(event: string, callback: EventCallback): void;
}

// Map to store the wrapped handlers for proper cleanup
const eventHandlerMap = new Map<string, Map<EventCallback, EventListenerOrEventListenerObject>>();

const eventBus: EventBus = {
  on<T = any>(event: string, callback: EventCallback<T>) {
    if (typeof document === 'undefined') return;

    console.log('Adding event listener for:', event);

    // Create wrapped handler
    const wrappedHandler = (e: CustomEvent<T>) => callback(e.detail);

    // Store the mapping for cleanup
    if (!eventHandlerMap.has(event)) {
      eventHandlerMap.set(event, new Map());
    }
    eventHandlerMap.get(event)!.set(callback, wrappedHandler);

    document.addEventListener(event, wrappedHandler);
  },
  dispatch(event, data) {
    if (typeof document === 'undefined') return;

    console.log('Dispatching event:', event, data);

    document?.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove(event, callback) {
    if (typeof document === 'undefined') return;

    console.log('Removing event listener for:', event);

    // Find the wrapped handler using the original callback
    const eventMap = eventHandlerMap.get(event);
    if (eventMap && eventMap.has(callback)) {
      const wrappedHandler = eventMap.get(callback);
      document.removeEventListener(event, wrappedHandler!);
      eventMap.delete(callback);

      // Clean up empty maps
      if (eventMap.size === 0) {
        eventHandlerMap.delete(event);
      }
    }
  },
};

export { eventBus };
